import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { v4 as uuidV4 } from 'uuid';
import { post } from '../actions/ajax'; // eslint-disable-line import/no-cycle
import loginActions from '../actions/loginActionCreators'; // eslint-disable-line import/no-cycle
import store from '../reducers/storeRegistration'; // eslint-disable-line import/no-cycle
import { getUser } from './paths';

// Source tag for render crashes caught by ErrorBoundary; the server uses this
// to additionally persist the report to the error cabinet.
export const ERROR_BOUNDARY_SOURCE = 'errorBoundary';
export const buildClientErrorPayload = function buildClientErrorPayload(error, info) {
  let overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _overrides$reference = overrides.reference,
    reference = _overrides$reference === void 0 ? uuidV4().toUpperCase() : _overrides$reference,
    source = overrides.source;
  return _objectSpread({
    url: global.location.href,
    userAgent: global.navigator.userAgent,
    name: error === null || error === void 0 ? void 0 : error.name,
    message: error === null || error === void 0 ? void 0 : error.message,
    stack: error === null || error === void 0 ? void 0 : error.stack,
    componentStack: info === null || info === void 0 ? void 0 : info.componentStack,
    time: new Date().toISOString(),
    reference
  }, source ? {
    source
  } : {});
};
export const canReportClientError = () => {
  const user = getUser();
  const _ref = store.getState().login || {},
    customer = _ref.customer;
  return Boolean((user === null || user === void 0 ? void 0 : user.access_token) && customer);
};
const logReportFailure = reportError => {
  // Best-effort telemetry must never mask the original render error.
  /* eslint-disable no-console */
  console.error('Failed to report client error:', reportError);
  /* eslint-enable no-console */
};
export const reportClientError = async function reportClientError(error, info) {
  let overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!canReportClientError()) {
    return;
  }
  const payload = buildClientErrorPayload(error, info, overrides);
  if (!payload.message || !String(payload.message).trim()) {
    return;
  }
  try {
    await post('/client-errors', payload);
  } catch (reportError) {
    var _reportError$response;
    // A stale access_token (e.g. user idle since last activity) returns 401.
    // Refresh once and retry once, mirroring the pattern used by other ajax
    // callers, so we don't silently drop the report.
    if ((reportError === null || reportError === void 0 || (_reportError$response = reportError.response) === null || _reportError$response === void 0 ? void 0 : _reportError$response.status) === 401) {
      try {
        await store.dispatch(loginActions.serverToken());
        await post('/client-errors', payload);
      } catch (retryError) {
        logReportFailure(retryError);
      }
      return;
    }
    logReportFailure(reportError);
  }
};